module.exports = __webpack_public_path__ + "static/media/logo-light.3033c01d.png";